import { useState, useEffect } from "react";
import { useFetchUserLocations } from "./useFetchUserLocations";
import { useFetchPayers } from "./useFetchPayers";

export function useAdminComponentsData() {
  // State variables
  const [selectedPayers, setSelectedPayers] = useState([]);
  const [selectedParentCompany, setSelectedParentCompany] = useState("");
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [allLocations, setAllLocations] = useState("");
  const [allPayers, setAllPayers] = useState("");

  // Fetch data using existing hooks
  const { data: locationFormatedDataSource = [] } = useFetchUserLocations(
    selectedParentCompany
  );
  const { data: payerDataSource = [] } = useFetchPayers();

  // Update allLocations when locationFormatedDataSource changes
  useEffect(() => {
    if (locationFormatedDataSource && locationFormatedDataSource.length > 0) {
      const locationValues = locationFormatedDataSource.map(
        (location) => location.value
      );
      setAllLocations(locationValues.join(","));
    } else {
      setAllLocations("");
    }
  }, [locationFormatedDataSource]);

  // Update allPayers when payerDataSource changes
  useEffect(() => {
    if (payerDataSource && payerDataSource.length > 0) {
      const payerIds = payerDataSource.map((payer) => payer.value);
      setAllPayers(payerIds.join(","));
    } else {
      setAllPayers("");
    }
  }, [payerDataSource]);

  // Reset selected locations when parent company changes
  useEffect(() => {
    setSelectedLocations([]);
  }, [selectedParentCompany]);

  return {
    // State values
    selectedPayers,
    selectedParentCompany,
    selectedLocations,
    allLocations,
    allPayers,

    // State setters
    setSelectedPayers,
    setSelectedParentCompany,
    setSelectedLocations,

    // Data sources for dropdowns
    locationFormatedDataSource,
    payerDataSource,
  };
}
